import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <div className='absolute-center max-width'>
      Footer.....
    </div>
  )
}

export default Footer
